import React from "react"
import PropTypes from "prop-types"

/**
 * Paso 5 — Requerimientos Adicionales
 * Imagen, material especial, equipo, hemoderivados, estudios y observaciones
 */
const StepExtras = ({
    // Imagen
    isRayosX, onCheckRayosX,
    isArcoC, onCheckArcoC,
    isNoRequiereImagen, onCheckNorequiereImagen,
    // Material especial
    equipoQuirirgicoHadError,
    hadEspecificaciones, onCheckEspecificaciones,
    equipoQuirirgico, onChangeEquipoQuirurgico,
    proveedorMaterial, onChangeProveedorMaterial,
    agregarMaterial,
    materialProveedorList,
    handleEliminarMaterialClick,
    MAX,
    // Equipo especial
    equipoEspecialHadError,
    hadRentaEquipos, onCheckRentaEquipos,
    equipoEspecial, onChangeEquipoEspecial,
    proveedorEquipoEspecial, onChangeProveedorEquipoEspecial,
    agregarEquipoEspecial,
    equipoEspecialProveedorList,
    handleEliminarEquipoClick,
    // Hemoderivados
    hemoderivadosHadError,
    hadHemoderivados, onCheckHemoderivados,
    hemoderivados, onChangeHemoderivados,
    // Muestra patológica
    hadEstudios, onCheckEstudios,
    isEstudiosTransoperatorios, onCheckEstudiosTransoperatocios,
    isEstudiosPostoperatorios, onCheckEstudiosPostoperatocios,
    isNoRequiereEstudios, onCheckNorequiereEstudios,
    // Observaciones
    hadExtras, onCheckExtras,
    extras, onChangeExtras,
}) => (
    <div className="rq-panel">

        {/* Servicios de imagen */}
        <div className="rq-field" id="contenedorImagenEstudios">
            <label className="rq-label">¿Requiere servicios de Imagen?</label>
            <div className="rq-content rq-check-group">
                <label className="rq-checkbox-item">
                    <input type="checkbox" id="checkRayosX" checked={isRayosX} onChange={onCheckRayosX}/> Rayos X
                </label>
                <label className="rq-checkbox-item">
                    <input type="checkbox" id="checkArcoC" checked={isArcoC} onChange={onCheckArcoC}/> Arco en C
                </label>
                <label className="rq-checkbox-item">
                    <input type="checkbox" id="checkNoImagen" checked={isNoRequiereImagen} onChange={onCheckNorequiereImagen}/> No se requiere
                </label>
            </div>
        </div>

        {/* Material especial */}
        <div className={equipoQuirirgicoHadError ? "rq-field rq-field--error" : "rq-field"} id="contenedorMaterialEspecial">
            <label className="rq-label">
                <input type="checkbox" checked={hadEspecificaciones} onChange={onCheckEspecificaciones} style={{marginRight:"8px"}}/>
                ¿Requiere material especial?
            </label>
            {hadEspecificaciones && (
                <div className="rq-content">
                    <input
                        type="text"
                        className="rq-input"
                        placeholder="Nombre del material"
                        value={equipoQuirirgico}
                        onChange={onChangeEquipoQuirurgico}
                        maxLength={MAX.material}
                    />
                    <input
                        type="text"
                        className="rq-input"
                        placeholder="Proveedor"
                        value={proveedorMaterial}
                        onChange={onChangeProveedorMaterial}
                        style={{marginTop:"8px"}}
                        maxLength={MAX.proveedor}
                    />
                    <p className="rq-add-btn" onClick={agregarMaterial()}>+ Agregar material</p>
                    {materialProveedorList.length > 0 && (
                        <div className="rq-table">
                            <div className="rq-table-head">
                                <span>Material</span><span>Proveedor</span><span></span>
                            </div>
                            {materialProveedorList.map(item => (
                                <div className="rq-table-row" key={item.id}>
                                    <span>{item.MaterialNombre}</span>
                                    <span>{item.MaterialProveedor}</span>
                                    <span className="rq-remove" onClick={handleEliminarMaterialClick(item)}>Quitar</span>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}
        </div>

        {/* Equipo especial */}
        <div className={equipoEspecialHadError ? "rq-field rq-field--error" : "rq-field"} id="contenedorRentaEquipos">
            <label className="rq-label">
                <input type="checkbox" checked={hadRentaEquipos} onChange={onCheckRentaEquipos} style={{marginRight:"8px"}}/>
                ¿Requiere equipo especial o accesorios?
            </label>
            {hadRentaEquipos && (
                <div className="rq-content">
                    <input
                        type="text"
                        className="rq-input"
                        placeholder="Equipo especial o accesorio"
                        value={equipoEspecial}
                        onChange={onChangeEquipoEspecial}
                        maxLength={MAX.material}
                    />
                    <input
                        type="text"
                        className="rq-input"
                        placeholder="Proveedor"
                        value={proveedorEquipoEspecial}
                        onChange={onChangeProveedorEquipoEspecial}
                        style={{marginTop:"8px"}}
                        maxLength={MAX.proveedor}
                    />
                    <p className="rq-add-btn" onClick={agregarEquipoEspecial()}>+ Agregar equipo</p>
                    {equipoEspecialProveedorList.length > 0 && (
                        <div className="rq-table">
                            <div className="rq-table-head">
                                <span>Equipo</span><span>Proveedor</span><span></span>
                            </div>
                            {equipoEspecialProveedorList.map(item => (
                                <div className="rq-table-row" key={item.id}>
                                    <span>{item.EquipoEspecialNombre}</span>
                                    <span>{item.EquipoEspecialProveedor}</span>
                                    <span className="rq-remove" onClick={handleEliminarEquipoClick(item)}>Quitar</span>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}
        </div>

        {/* Hemoderivados */}
        <div className={hemoderivadosHadError ? "rq-field rq-field--error" : "rq-field"} id="contenedorHemoderivados">
            <label className="rq-label">Requerimiento de sangre y/o hemoderivados</label>
            <div className="rq-content rq-check-group">
                <label className="rq-checkbox-item">
                    <input type="checkbox" checked={hadHemoderivados}  onChange={onCheckHemoderivados}/> Sí se requiere
                </label>
                <label className="rq-checkbox-item">
                    <input type="checkbox" checked={!hadHemoderivados} onChange={onCheckHemoderivados}/> No se requiere
                </label>
            </div>
            {hadHemoderivados && (
                <div className="rq-content">
                    <textarea
                        className="rq-textarea"
                        id="hemoderivados"
                        value={hemoderivados}
                        onChange={onChangeHemoderivados}
                        rows="3"
                        placeholder="Especifique el tipo y cantidad..."
                        maxLength={MAX.hemoderivados}
                    />
                </div>
            )}
        </div>

        {/* Muestra patológica */}
        <div className="rq-field" id="contenedorMuestraPatologica">
            <label className="rq-label">
                <input type="checkbox" checked={hadEstudios} onChange={onCheckEstudios} style={{marginRight:"8px"}}/>
                ¿Se obtiene muestra patológica?
            </label>
            {hadEstudios && (
                <div className="rq-content rq-check-group">
                    <label className="rq-checkbox-item">
                        <input type="checkbox" checked={isEstudiosTransoperatorios} onChange={onCheckEstudiosTransoperatocios}/> Transoperatorios
                    </label>
                    <label className="rq-checkbox-item">
                        <input type="checkbox" checked={isEstudiosPostoperatorios} onChange={onCheckEstudiosPostoperatocios}/> Postoperatorios
                    </label>
                    <label className="rq-checkbox-item">
                        <input type="checkbox" checked={isNoRequiereEstudios} onChange={onCheckNorequiereEstudios}/> No se requiere
                    </label>
                </div>
            )}
        </div>

        {/* Observaciones */}
        <div className="rq-field" id="contenedorExtras">
            <label className="rq-label">
                <input type="checkbox" checked={hadExtras} onChange={onCheckExtras} style={{marginRight:"8px"}}/>
                Observaciones adicionales
            </label>
            {hadExtras && (
                <div className="rq-content">
                    <textarea
                        className="rq-textarea"
                        id="extras"
                        value={extras}
                        onChange={onChangeExtras}
                        rows="4"
                        placeholder="Especifique cualquier observación relevante..."
                        maxLength={MAX.extras}
                    />
                </div>
            )}
        </div>

    </div>
)

export default StepExtras

StepExtras.propTypes = {
    // Imagen
    isRayosX:                       PropTypes.bool.isRequired,
    onCheckRayosX:                  PropTypes.func.isRequired,
    isArcoC:                        PropTypes.bool.isRequired,
    onCheckArcoC:                   PropTypes.func.isRequired,
    isNoRequiereImagen:             PropTypes.bool.isRequired,
    onCheckNorequiereImagen:        PropTypes.func.isRequired,
    // Material especial
    equipoQuirirgicoHadError:       PropTypes.bool.isRequired,
    hadEspecificaciones:            PropTypes.bool.isRequired,
    onCheckEspecificaciones:        PropTypes.func.isRequired,
    equipoQuirirgico:               PropTypes.string.isRequired,
    onChangeEquipoQuirurgico:       PropTypes.func.isRequired,
    proveedorMaterial:              PropTypes.string.isRequired,
    onChangeProveedorMaterial:      PropTypes.func.isRequired,
    agregarMaterial:                PropTypes.func.isRequired,
    materialProveedorList:          PropTypes.array.isRequired,
    handleEliminarMaterialClick:    PropTypes.func.isRequired,
    MAX:                            PropTypes.object.isRequired,
    // Equipo especial
    equipoEspecialHadError:         PropTypes.bool.isRequired,
    hadRentaEquipos:                PropTypes.bool.isRequired,
    onCheckRentaEquipos:            PropTypes.func.isRequired,
    equipoEspecial:                 PropTypes.string.isRequired,
    onChangeEquipoEspecial:         PropTypes.func.isRequired,
    proveedorEquipoEspecial:        PropTypes.string.isRequired,
    onChangeProveedorEquipoEspecial: PropTypes.func.isRequired,
    agregarEquipoEspecial:          PropTypes.func.isRequired,
    equipoEspecialProveedorList:    PropTypes.array.isRequired,
    handleEliminarEquipoClick:      PropTypes.func.isRequired,
    // Hemoderivados
    hemoderivadosHadError:          PropTypes.bool.isRequired,
    hadHemoderivados:               PropTypes.bool.isRequired,
    onCheckHemoderivados:           PropTypes.func.isRequired,
    hemoderivados:                  PropTypes.string.isRequired,
    onChangeHemoderivados:          PropTypes.func.isRequired,
    // Muestra patológica
    hadEstudios:                    PropTypes.bool.isRequired,
    onCheckEstudios:                PropTypes.func.isRequired,
    isEstudiosTransoperatorios:     PropTypes.bool.isRequired,
    onCheckEstudiosTransoperatocios: PropTypes.func.isRequired,
    isEstudiosPostoperatorios:      PropTypes.bool.isRequired,
    onCheckEstudiosPostoperatocios: PropTypes.func.isRequired,
    isNoRequiereEstudios:           PropTypes.bool.isRequired,
    onCheckNorequiereEstudios:      PropTypes.func.isRequired,
    // Observaciones
    hadExtras:                      PropTypes.bool.isRequired,
    onCheckExtras:                  PropTypes.func.isRequired,
    extras:                         PropTypes.string.isRequired,
    onChangeExtras:                 PropTypes.func.isRequired,
}